// extracted by mini-css-extract-plugin
export var downloadBtn = "DownloadDropdown-module--downloadBtn--79cff";
export var downloadDropdownWrapper = "DownloadDropdown-module--downloadDropdownWrapper--14774";
export var select = "DownloadDropdown-module--select--82cf2";